import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UnitOfMeasure } from '../../app/models/UnitOfMeasure';
import { ModalDirective } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { Storage } from '../../../node_modules/@ionic/storage';

@Component({
  selector: 'page-units-of-measure',
  templateUrl: 'units-of-measure.html',
})
export class UnitsOfMeasurePage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('unitOfMeasureModal')
  private unitOfMeasureModal: ModalDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('unitOfMeasureForm')
  private unitOfMeasureForm: NgForm;

  private pageName: string = 'page-units-of-measure';
  private unitsOfMeasure: UnitOfMeasure[] = [];
  private currentUnitOfMeasure = new UnitOfMeasure();
  private navControllerService: NavControllerService;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private app: App,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getUnitsOfMeasure();
  }

  private getUnitsOfMeasure() {
    this.backendService.getUnitsOfMeasure().subscribe(
      (data) => {
        this.unitsOfMeasure = data;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addUnitOfMeasure() {
    this.currentUnitOfMeasure = new UnitOfMeasure();
    this.unitOfMeasureForm.resetForm();
    this.showUnitOfMeasureModal();
  }

  editUnitOfMeasure(unitOfMeasure: UnitOfMeasure) {
    this.currentUnitOfMeasure = unitOfMeasure;
    this.showUnitOfMeasureModal();
  }

  submitUnitOfMeasure(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .saveOrUpdateUnitOfMeasure(this.currentUnitOfMeasure)
      .subscribe(
        (unitOfMeasure) => {
          this.getUnitsOfMeasure();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        btnEvent.disabled = false;
        this.closeUnitOfMeasureModal();
      });
  }

  deleteUnitOfMeasure() {
    this.backendService
      .deleteUnitOfMeasure(this.currentUnitOfMeasure)
      .subscribe(
        (data) => {
          this.getUnitsOfMeasure();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeConfirmModal();
      });
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showUnitOfMeasureModal() {
    this.unitOfMeasureModal.show();
  }

  closeUnitOfMeasureModal() {
    this.unitOfMeasureModal.hide();
  }

  showConfirmModal(unitOfMeasure) {
    this.currentUnitOfMeasure = unitOfMeasure;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showTaxRatesPage() {
    this.navControllerService.showTaxRatesPage();
  }

  showCardTypesPage() {
    this.navControllerService.showCardTypesPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/units-of-measure/units-of-measure.ts